import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/portfoliofooter.css";
import WeeklyNewsletter from "./weeklynewsletter";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const logoX =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/x.svg";
const logoInstagram =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/instagram.svg";

const logoLinkedin =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/linkedin.svg";

const logoYT =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/youtube.svg";

const logoFacebook =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/facebook.svg";
export default function PortfolioFooter() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="portfoliofooter">
        <div className="portfoliofooterleft">
          <div className="portfoliofooterleftlogo">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="portfoliofooterleftcontent">
            <div className="portfoliofooterleftcontentone">
              <h6>Product</h6>
              <ul>
                <li onClick={() => navigate("/portfolio")}>Features</li>
                <li onClick={() => navigate("/pricing")}>Pricing</li>
                <li onClick={() => navigate("/faq")}>FAQs</li>
                {/* <li onClick={() => navigate("/blog-home")}>Blog</li> */}
                <li onClick={() => navigate("/contact")}>Contact</li>
                <li onClick={() => navigate("/feedback")}>Feedback</li>
              </ul>
            </div>
            {/* <div className="portfoliofooterleftcontenttwo">
              <h6>Company</h6>
              <ul>
                <li>Team</li>

                <li>Blog</li>
                <li onClick={() => navigate("/contact")}>Contact</li>
                <li>Careers</li>
              </ul>
            </div> */}
          </div>
        </div>
        <WeeklyNewsletter />
      </div>
      <div className="portfoliofooterbottom">
        <div className="portfoliofooterbottomleft">
          <ul>
            <li>©2024 Neurogen </li>
            <li onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => navigate("/terms")}>Terms of Service</li>
            <li onClick={() => navigate("/cancellation-policy/")}>
              Cancellation/Refund Policy
            </li>
            {/* <li>Cookies</li> */}
          </ul>
        </div>
        <div className="portfoliofooterbottomright">
          <ul>
            {/* <li>
              <img src={logoFacebook} alt="Facebook" />
            </li> */}
            <a
              href="https://www.instagram.com/neurogen.app/profilecard/?igsh=MW4wcW93emFpamprZQ=="
              target="_blank"
            >
              <li>
                <img src={logoInstagram} alt="Instagram" />
              </li>
            </a>
            <a
              href="https://x.com/neurogenapp/status/1856551952718671888?s=46"
              target="_blank"
            >
              <li>
                <img src={logoX} alt="X" />
              </li>
            </a>

            {/* <li>
              <img src={logoLinkedin} alt="Linkedin" />
            </li>
            <li>
              <img src={logoYT} alt="YouTube" />
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
}
